import { render, staticRenderFns } from "./FollowupsTab.vue?vue&type=template&id=4de9d9d2"
import script from "./FollowupsTab.vue?vue&type=script&lang=js"
export * from "./FollowupsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports